"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : FEEDBACK BUTTON : STYLES --------------- ++++++++++ */


var _default = {
  feedback: {
    height: (0, _index.pxToEm)(38),
    width: (0, _index.pxToEm)(152),
    color: _index.theme.color.supporting.dark.swatch,
    cursor: 'pointer',
    position: 'fixed',
    bottom: '50%',
    zIndex: '900',
    fontSize: (0, _index.pxToEm)(14),
    fontWeight: '500',
    backgroundColor: '#F2F4F8',
    borderRadius: '10px 10px 0px 0px',
    '&.position-right': {
      transform: 'rotate(270deg)',
      right: "calc(0px - ".concat((0, _index.pxToEm)(57), ")")
    },
    '&.position-left': {
      transform: 'rotate(-270deg)',
      left: "calc(0px - ".concat((0, _index.pxToEm)(57), ")")
    },
    '& .icon': {
      fontSize: (0, _index.pxToEm)(10)
    }
  }
};
exports.default = _default;